import c from "@emotion/styled/base";
const a = /* @__PURE__ */ c("div", process.env.NODE_ENV === "production" ? {
  target: "e1xipoi00"
} : {
  target: "e1xipoi00",
  label: "Line"
})("height:12px;width:", ({
  width: b
}) => b ?? 160, "px;max-width:100%;border-radius:", ({
  theme: b
}) => b.radius.large, ";background-color:", ({
  theme: b
}) => b.colors.default.alpha, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvU2tlbGV0b24vTGluZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRWtEIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvU2tlbGV0b24vTGluZS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmV4cG9ydCBjb25zdCBMaW5lID0gc3R5bGVkLmRpdjx7IHdpZHRoPzogbnVtYmVyIH0+YFxuICAgIGhlaWdodDogMTJweDtcbiAgICB3aWR0aDogJHsoeyB3aWR0aCB9KSA9PiB3aWR0aCA/PyAxNjB9cHg7XG4gICAgbWF4LXdpZHRoOiAxMDAlO1xuICAgIGJvcmRlci1yYWRpdXM6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUucmFkaXVzLmxhcmdlfTtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbG9ycy5kZWZhdWx0LmFscGhhfTtcbmA7XG4iXX0= */"));
export {
  a as Line
};
